const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class Fortifications extends Tactic {
    constructor() {
        super(
            Age.Age2,
            TacticNames.Fortifications,
            [0, 0, 2],
            "5(3)",
            {}
        )
    }
}

module.exports = Fortifications;